import { ToastProps } from "@cividao/components"
import React from "react"

// STORAGE KEYS
export const THEME_MODE_STORAGE_KEY = "theme-mode"
export const FIRST_NFT_GENERATED_STORAGE_KEY = "first-nft-generated"
export const FIRST_VOTE_STORAGE_KEY = "first-vote"

// CONTEXT
interface LayoutContextInterface {
  themeMode: ThemeMode
  setThemeMode: (mode: ThemeMode) => void
  addToast: (toast: Omit<ToastProps, "id" | "isExiting" | "onClose"> & { duration?: number }) => void
  removeToast: (id: string) => void
  clearAllToasts: () => void
}

interface LayoutProviderProps extends React.PropsWithChildren {}

// THEME
enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export { type LayoutContextInterface, type LayoutProviderProps, ThemeMode }
